import { Link } from 'gatsby';
import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { v4 as uuidv4 } from 'uuid';
import Img from 'gatsby-image';
import ContentPageMobilStyle from '../styles/ContentPageMobilStyle';
import TextBlock from './TextBlock';

export default function ContentPageMobil({ pageContent, location }) {


  console.log(pageContent)
  const checkPage = () => {
    if (pageContent.props.data.realisation) {
      return pageContent.props.data.realisation;
    }
    if (pageContent.props.data.etude) {
      return pageContent.props.data.etude;
    }
    if (pageContent.props.data.actu) {
      return pageContent.props.data.actu;
    }
    if (pageContent.props.data.querypage) {
      return pageContent.props.data.queryPage;
    }
    
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const testPath = () => {
    if (/etudes/.test(location.pathname)) {
      return 'Etudes';
    }
    if (/realisations/.test(location.pathname)) {
      return 'Réalisations';
    }
    if (/actualites/.test(location.pathname)) {
      return 'Actualités';
    }
    if (/contact/.test(location.pathname)) {
      return 'Contact';
    }
  };

  return (
    <ContentPageMobilStyle>
      {/* <h2> {testPath()}</h2> */}
      <h3>
        {checkPage().date} {checkPage().name}{' '}
        {checkPage().place ? `/ ${checkPage().place}` : ''}
      </h3>
      <Slider {...settings}>
        {checkPage().images &&
          checkPage().images.map(
            (image) =>
              image.asset && (
                <Img
                  fluid={image.asset.fluid}
                  key={uuidv4()}
                  alt={checkPage().name}
                />
              )
          )}
      </Slider>

      <TextBlock pageData={checkPage()} place={checkPage().lieux} />
    </ContentPageMobilStyle>
  );
}
